import styled from 'styled-components';
import * as Cards from 'eCoach/_styles/Cards.style';
import breakpoints from 'theme/atoms/breakpoints';

export const Card = styled(Cards.Card)`
  height: unset;
  justify-content: space-between;
  width: fit-content;
  flex: 1 1 400px;

  @media (max-width: ${breakpoints.tablet}) {
    flex: 1 1 100%;
    max-width: 100%;
    width: 100%;
  }
`;

export const InsightsSection = styled('div')`
  display: flex;
  gap: 60px;
  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
    gap: 30px;
  }
`;

export const Insight = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const InsightLabel = styled('div')`
  align-items: center;
  display: flex;
  gap: 5px;

  svg {
    height: 17px;
    width: 17px;
  }
`;
